<mat-paginator
  #paginator
  class="paginator"
  [ngClass]="{ hide: datasource.data.length === 0 }"
  [length]="datasource.data.length"
  [pageSize]="pageSize"
  [showFirstLastButtons]="
    window.innerWidth > 375 ? showFirstLastButtons : false
  "
  [hidePageSize]="window.innerWidth < 376"
  [pageSizeOptions]="pageSizeOptions"
  [pageIndex]="pageIndex"
></mat-paginator>
